/**
 * PostgreSQL table maintenance script generation — VACUUM / ANALYZE / REPACK.
 *
 * Pure string builders; scripts are opened in a query tab (index-REBUILD
 * model), never executed directly by this module.
 */

export type TableMaintenanceAction = 'vacuum' | 'analyze' | 'repack' | 'repack-concurrently';

function q(ident: string): string {
  return `"${ident.replace(/"/g, '""')}"`;
}

/**
 * Maintenance scripts are generated into a query tab (index-REBUILD model) —
 * never executed directly. REPACK is PostgreSQL 19+: when the server is older
 * or unknown we still generate the script but prepend a warning comment, so
 * the menu stays version-agnostic (graceful, like the Property Graphs folder).
 */
export function generatePgsqlMaintenanceScript(
  action: TableMaintenanceAction,
  schema: string,
  table: string,
  pgMajorVersion: number | null,
): string {
  const target = `${q(schema)}.${q(table)}`;
  const repackWarning =
    pgMajorVersion !== null && pgMajorVersion >= 19
      ? ''
      : `-- NOTE: REPACK requires PostgreSQL 19+ (this server reports ${pgMajorVersion ?? 'an unknown version'}).\n`;
  switch (action) {
    case 'vacuum':
      return `VACUUM (VERBOSE, ANALYZE) ${target};\n`;
    case 'analyze':
      return `ANALYZE VERBOSE ${target};\n`;
    case 'repack':
      return `${repackWarning}REPACK ${target};\n`;               // ← PG19-FACTS (b)
    case 'repack-concurrently':
      return `${repackWarning}REPACK (CONCURRENTLY) ${target};\n`; // ← PG19-FACTS (b)
  }
}
